import {
  makeKolInfo1,
  KolInfoMaker,
  makeKolInfo2,
  makeKolInfo3,
  makeKolInfo4,
  makeKolInfo5,
} from '@/constants/mock-data/kol-info'
import { SupportedLanguages } from '@/i18n/config'
import { SimilarKols } from '@/store/kol-detail'

const makeMockSimilarKol = (maker: KolInfoMaker) => {
  return (locale?: SupportedLanguages): SimilarKols => {
    const kol = maker(locale)

    return {
      uuid: kol.id,
      name: kol.name,
      follower: kol.follower,
    }
  }
}

const mockSimilarKol1 = makeMockSimilarKol(makeKolInfo1)()
const mockSimilarKol2 = makeMockSimilarKol(makeKolInfo2)()
const mockSimilarKol3 = makeMockSimilarKol(makeKolInfo3)()
const mockSimilarKol4 = makeMockSimilarKol(makeKolInfo4)()
const mockSimilarKol5 = makeMockSimilarKol(makeKolInfo5)()

const mockSimilarKolList = [
  mockSimilarKol1,
  mockSimilarKol2,
  mockSimilarKol3,
  mockSimilarKol4,
  mockSimilarKol5,
]

export { mockSimilarKolList }
